import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["counter", "form", "limitMessage"]
  static values = {
    used: Number,
    limit: Number
  }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasFormTarget || this.limitValue < 0) return

    const atLimit = this.usedValue >= this.limitValue
    const submitButton = this.formTarget.querySelector("[type='submit']")

    if (submitButton) submitButton.disabled = atLimit
    if (this.hasLimitMessageTarget) this.limitMessageTarget.classList.toggle("d-none", !atLimit)
    if (this.hasCounterTarget) this.counterTarget.classList.toggle("bg-danger", atLimit)
  }
}
